export function validate() {

    // Get the user's preferred motion settings
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    $('form.validate, form.needs-validation').submit(function (e) {

        // Don't automatically post data on submit
        e.preventDefault();

        // Declare Variables
        const form = $(this);
        const feedback = form.find('.feedback');
        const button = form.find('button[type="submit"]');
        const url = form.attr('action');
        const data = new FormData(this);
        const alert_message = feedback.find('.alert');
        const language = $('html').attr('lang');
        let html = '';
        const buttonValue = button.html();

        // Get all languages
        let ButtonLoadingValue;
        let warningMessage;
        let errorMessage;
        switch (language) {
            case 'en':
                ButtonLoadingValue = 'Loading';
                warningMessage = 'Could not send form';
                errorMessage = 'An unspecified error has occurred while processing your request. Please try again.'
            break;
            case 'nl':
                ButtonLoadingValue = 'Laden';
                warningMessage = 'Probleem met versturen';
                errorMessage = 'Er heeft zich een onverwachts probleem voorgedaan bij het verwerken van uw verzoek. Probeer het nog eens.'
            break;
        }

        // Return error if Honeypot input field is missing
        if (form.find('input[name="gender"]').length === 0) {
            alert('Honeypot field is missing...');
            return false;
        }

        // Return error if feedback container div is missing
        if (feedback.length === 0) {
            alert('<div> with class ".feedback" is missing...');
            return false;
        }

        // Change button to disabled when form is busy processing the data based on language
        button.html(ButtonLoadingValue).attr('disabled', 'disabled');
        button.append('<span class="basicon icon-spinner" aria-hidden="true"></span>');

        // Remove existing alert messages when attempting to submit
        feedback.hide(((reducedMotion.matches) ? 0 : 200), function() {
            alert_message.remove();
        });

        // Get Form Response
        axios.post(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(function (response) {

            let status = response.data.status;
            let warnings = response.data.warnings;
            let hasError = response.data.hasError;
            let message = response.data.message;

            // Skip following steps and go to new page if a redirect is called
            if (response.data.redirect) {
                window.location = response.data.redirect;
                return false;
            }

            // Otherwise, indicate that the form has been validated by the client (add the 'required' attribute for fields that must undergo client-side validation)
            form.addClass('was-validated');

            // If an error occurs, populate the alert with negative feedback
            if (status === 'error') {

                if (!Array.isArray(warnings)) {
                    warnings = [];
                }

                html += '<div class="alert alert-danger alert-dismissible" role="alert"><button type="button" class="alert-dismiss" aria-label="Close"></button><div class="alert-heading"><span class="basicon icon-attention-triangle" aria-hidden="true"></span><strong>' + warningMessage + '</strong></div><hr><ul>';

                // Show all the warnings
                if (warnings.length > 0) {
                    $(warnings).each(function(index, value) {
                        html += '<li><span class="basicon icon-cancel-circled" aria-hidden="true"></span>' + value + '</li>';
                    });
                } else {
                    html += '<li>' + message + '</li>';
                }

                html += '</ul></div>';

            }

            // If the form is sent successfully, populate the alert with positive feedback
            if (status === 'success') {
                html += '<div class="alert alert-success alert-dismissible" role="alert"><button type="button" class="alert-dismiss" aria-label="Close"></button><div class="alert-heading"><span class="basicon icon-check-circled" aria-hidden="true"></span><strong style="font-weight:normal;">' + message + '</strong></div></div>'
            }

            // Show the alert and revert the button state
            feedback.html(html).show(((reducedMotion.matches) ? 0 : 200));
            button.html(buttonValue).attr('disabled', false);

            if (response.data.clear) {
                form.trigger('reset');
            }

        // If an internal error occurs, alert the user
        }).catch(function (error) {
            console.log(error); //log the error

            // Show the alert and revert the button state
            feedback.html('<div class="alert alert-danger alert-dismissible" role="alert"><button type="button" class="alert-dismiss" aria-label="Close"></button><div class="alert-heading"><span class="basicon icon-attention-triangle" aria-hidden="true"></span><strong style="font-weight:normal;">' + errorMessage + '</strong></div></div>').show(((reducedMotion.matches) ? 0 : 200));
            button.html(buttonValue).attr('disabled', false);
        });

    });

    // Handle the dismissing
    $(document).on('click', '.alert-dismiss', function(e) {
        $(e.target).parents('.feedback').hide(((reducedMotion.matches) ? 0 : 200), function() {
            $(this).find('.alert').remove();
            $(this).closest('form').removeClass('was-validated');
        });
    });

    return 'validate';

}